<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.cerrado ? "lock_open " : "lock" }}</v-icon>
          {{
            form.cerrado
              ? "ABRIR DETALLE PLANILLA "
              : "CERRAR DETALLE PLANILLA "
          }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="px-2">
          <v-layout row wrap class="text-xs-center blue--text">
            <v-flex xs12
              ><b
                >{{ this.form.ap_paterno }} {{ this.form.ap_materno }}
                {{ this.form.nombres }}</b
              ></v-flex
            >
            <v-flex shrink> <b> GESTIÓN:</b> {{ this.form.gestion }} </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink><b> MES:</b> {{ this.form.mes }} </v-flex>
            <v-flex xs12>
              <v-text-field
                class="text-field-reducido-border"
                v-model="form.justificacion"
                :rules="$validate(['required'])"
                required
                label="Justificación*"
                outline
                clearable
                success
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
export default {
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      valid: true,
      form: {},
      dialog: false,
      loading: false,
      user: this.$storage.get("user")
    };
  },
  mounted() {
    this.$bus.$on("openDialogAbrirCerrarPlanillaDetalle", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cerrar la planilla
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (!this.form.gestion || !this.form.mes) {
          this.$message.info("Seleccione gestión y mes");
          return;
        }
        this.$confirm(
          this.form.cerrado
            ? "¿Está seguro de abrir el detalle de planilla seleccionada?"
            : "¿Está seguro de cerrar el detalle de planilla seleccionada?",
          async () => {
            this.loading = true;
            const id_planilla_asistencia = this.form.id_planilla_asistencia;
            await this.$service.graphql({
              query: `
                mutation edit($id: ID!, $planilla_asistencia: EditPlanillaAsistencia!) {
                  planillaAsistenciaEdit(id: $id, planilla_asistencia: $planilla_asistencia) {
                    id
                  }
                }
              `,
              variables: {
                id: id_planilla_asistencia,
                planilla_asistencia: {
                  cerrado: this.form.cerrado ? false : true
                }
              }
            });
            await this.$service.graphql({
              query: `
								mutation add($seguimiento_planilla: NewSeguimientoPlanilla!){
									seguimientoPlanillaAdd(seguimiento_planilla: $seguimiento_planilla){
										id
									}
								}
							`,
              variables: {
                seguimiento_planilla: {
                  mes: this.form.mes,
                  gestion: this.form.gestion,
                  id_persona: this.form.id_persona,
                  motivo: this.form.justificacion,
                  cerrado: this.form.cerrado ? false : true,
                  id_estado: 1,
                  _user_created: this.user.id
                }
              }
            });
            this.close();
            this.loading = false;
            this.$message.success();
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.$bus.$emit("closeDialogAbrirCerrarPlanillaDetalle");
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/dialogs/AbrirCerrarPlanillaDetalle.vue